'use client';

import { c as _c } from "react/compiler-runtime";
import { loadingIndicatorCSS, loadingOverlayCSS } from './LoadingIndicator.css';
import { useIsNavigating } from '@/globals/routing/DOPRouter';
export const LoadingIndicator = () => {
  const $ = _c(1);
  const isNavigating = useIsNavigating();
  if (!isNavigating) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><i className={loadingOverlayCSS} /><i className={loadingIndicatorCSS} /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};